import Tooltip from './DepositTooltip'

export default Tooltip
